import { Belts } from "./types";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";

export function getBeltClassifications(designation: SingleDesignation | null | undefined): Belts | null {
  if (!designation) {
    return null;
  }

  return {
    designation,
    greyBeltPercentage: Math.round(designation.category_coverage_percentage ?? 0),
  };
}
